import { Payment } from '@/@types/payment'
import { create } from 'zustand'

interface FilterState {
  startDate?: string
  endDate?: string
  isLoading: boolean
  payments: Payment[] | undefined
  setStartDate: (date?: string) => void
  setEndDate: (date?: string) => void
  setPayments: (payments: Payment[]) => void
  setIsLoading: (isLoading: boolean) => void
}

export const useBillsStore = create<FilterState>((set) => ({
  startDate: undefined,
  endDate: undefined,
  payments: undefined,
  isLoading: false,
  setStartDate: (date) => set({ startDate: date }),
  setEndDate: (date) => set({ endDate: date }),
  setPayments: (payments) => set({ payments }),
  setIsLoading: (isLoading) => set({ isLoading }),
}))
